import { render, staticRenderFns } from "./InGame.vue?vue&type=template&id=2f1edef5&"
import script from "./InGame.vue?vue&type=script&lang=js&"
export * from "./InGame.vue?vue&type=script&lang=js&"
import style0 from "./InGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1edef5')) {
      api.createRecord('2f1edef5', component.options)
    } else {
      api.reload('2f1edef5', component.options)
    }
    module.hot.accept("./InGame.vue?vue&type=template&id=2f1edef5&", function () {
      api.rerender('2f1edef5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/announcement/InGame.vue"
export default component.exports